export const createProductSlice = (set) => ({
    products: [],
    setProducts: (products) => set({ products }),
});
